var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { plainToClass } from 'class-transformer';
import { MedicalMachine } from 'models';
import Model from 'models/Model';
var OrderEntity = /** @class */ (function (_super) {
    __extends(OrderEntity, _super);
    function OrderEntity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderEntity.prototype.getId = function () {
        return Number(this.id);
    };
    OrderEntity.prototype.getName = function () {
        return this.name || '';
    };
    OrderEntity.prototype.setName = function (name) {
        this.name = name;
    };
    OrderEntity.prototype.getCode = function () {
        return this.code || '';
    };
    OrderEntity.prototype.setCode = function (code) {
        this.code = code;
    };
    OrderEntity.prototype.getDescription = function () {
        return this.description || '';
    };
    OrderEntity.prototype.setDescription = function (description) {
        this.description = description;
    };
    OrderEntity.prototype.getEntityType = function () {
        return this.entity_type;
    };
    OrderEntity.prototype.setEntityType = function (entityType) {
        this.entity_type = entityType;
    };
    OrderEntity.prototype.getConfig = function () {
        return this.config || {};
    };
    OrderEntity.prototype.setConfig = function (config) {
        this.config = config;
    };
    OrderEntity.prototype.isEnabled = function () {
        return this.is_enabled !== false;
    };
    OrderEntity.prototype.hasPackagePrice = function () {
        return this.has_package_price === true;
    };
    OrderEntity.prototype.getPackageId = function () {
        return this.package_id != null ? Number(this.package_id) : undefined;
    };
    OrderEntity.prototype.getPackageUnitMeasurementId = function () {
        return this.package_unit_measurement_id != null
            ? Number(this.package_unit_measurement_id)
            : undefined;
    };
    OrderEntity.prototype.setEnabled = function (enabled) {
        this.is_enabled = enabled;
    };
    OrderEntity.prototype.getMedicalMachines = function () {
        return plainToClass(MedicalMachine, (this.medical_machines || []));
    };
    OrderEntity.prototype.getMedicalMachineLinks = function () {
        return this.order_entity_medical_machines || [];
    };
    OrderEntity.prototype.getClinicLinks = function () {
        return this.clinic_order_entities || [];
    };
    OrderEntity.prototype.getClinicIds = function () {
        return this.getClinicLinks().map(function (link) { return Number(link.clinic_id); });
    };
    return OrderEntity;
}(Model));
export default OrderEntity;
